export enum IntegrationType {
  EMAIL = "EMAIL",
  FORTNOX = "FORTNOX",
  SPIRIS = "SPIRIS",
  BJORN_LUNDEN = "BJORN_LUNDEN",
  PERSONALKOLLEN = "PERSONALKOLLEN",
  VIVA = "VIVA",
  ELAVON = "ELAVON",
  PAYTRIM = "PAYTRIM",
  WESTPAY_CLOUD = "WESTPAY_CLOUD",
  SOFTPAY = "SOFTPAY",
  MARKETPAY = "MARKETPAY",
  NETS = "NETS",
  SHOPIFY = "SHOPIFY",
}

export const BOOKKEEPING_INTEGRATIONS = [
  IntegrationType.EMAIL,
  IntegrationType.FORTNOX,
  IntegrationType.SPIRIS,
] as const;

export const PRODUCT_SYNC_INTEGRATIONS = [IntegrationType.SHOPIFY] as const;

export const ACQUIRER_INTEGRATIONS = [
  IntegrationType.VIVA,
  IntegrationType.ELAVON,
  IntegrationType.PAYTRIM,
] as const;

export const SALES_EXPORT_INTEGRATIONS = [
  IntegrationType.PERSONALKOLLEN,
] as const;
